import type { DiagnosticFinding } from "../diagnostics/types";

import type { RepairVerification } from "./types";

export function planRepairVerification(
  finding: DiagnosticFinding,
): RepairVerification[] {
  const verification: RepairVerification[] = [];

  if (finding.requiresMutation) {
    verification.push(
      {
        type: "typecheck",
        commandOrMethod: "npm run typecheck",
        required: true,
      },
      {
        type: "test",
        commandOrMethod: "run affected and regression tests",
        required: true,
      },
    );
  }

  if (
    finding.category === "build" ||
    finding.category === "configuration" ||
    finding.category === "dependency" ||
    finding.category === "architecture"
  ) {
    verification.push({
      type: "build",
      commandOrMethod: "npm run build:production",
      required: true,
    });
  }

  if (finding.category === "deployment") {
    verification.push({
      type: "infrastructure",
      commandOrMethod:
        "verify governed deployment configuration without deploying",
      required: true,
    });
  }

  if (finding.category === "database") {
    verification.push({
      type: "database",
      commandOrMethod: "verify migration and database state without mutation",
      required: true,
    });
  }

  if (finding.category === "security") {
    verification.push({
      type: "security",
      commandOrMethod: "run security regression and audit",
      required: true,
    });
  }

  if (finding.requiresLiveVerification) {
    verification.push({
      type: "manual_evidence",
      commandOrMethod: "collect authoritative live evidence",
      required: true,
    });
  }

  return verification;
}
